var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.header,"items":_vm.dat,"search":_vm.search}})}
var staticRenderFns = []

export { render, staticRenderFns }